import { styled } from '@mui/system';

const RootDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#EFF7FF',
  padding: '15px 15px',
  border: '1px solid #0A7ABE',
  borderRadius: '10px',
  cursor: 'pointer !important',
  marginTop: '15px',
});

const InsuranceText = styled('div')({
  fontFamily: 'Poppins',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '21px',
  letterSpacing: '0.16px',
  textAlign: 'center',
  color: '#0A7ABE',
});

export { RootDiv, InsuranceText };
